import "./contactPage.css"
import ContactForm from "../contactForm"
import Map from  "../map"
const ContactPage=()=>{
return(<>
   <section className="py-3 pb-5 contact-page">
   <div className="container">
   <div className="position-relative heading-container mx-auto ">
                       <h2 className="heading">
                        C<span className="heading-span">ONTACT</span>    </h2>
                      <div className="line"></div>
                    </div>
     <div className="row gap-5">
        <div className="col-md-10 mx-auto col-lg-6 order-2 order-lg-1  contact-page-left py-5 px-auto">
<h4 className="fw-bold">Get in Touch with Best Deal Electricals</h4>
<p className="">Feel free to reach out to us using any of the following methods:</p>

<h4 className="mt-4">Address:</h4>
<p className="">Plot No - 256, Phase 9, Industrial Area Mohali,Punjab</p>

<h4 className="mt-4">Phone:</h4>
<p className=""> +91 9779096815 <br/>
+91 9779490815 <br/>
+91 9779188815 </p>

<h4 className="mt-4">Emails:</h4>
<p className="">admin@mamtabestdealelectricals.com <br/>bestdealelectricals4444@gmail.com  </p>

        </div>
        <div className="col-lg-4 col-md-10 mx-auto order-1 order-lg-2 contact-page-left pt-4">
           <div className="contactPage-form "><ContactForm/></div>
        </div>
     </div>
     </div>
   </section>
   <Map/>
</>)
}
export default ContactPage